$(window).on('load', function () {

  // URLの取得
  var url = location.href

  // パスの取得
  var path = location.pathname

  // パラメーターの取得
  var param = location.search

  // ページ内アンカーの取得
  var anc = location.hash

  var fix_path = path.split('/');

  if (!(fix_path[1])) {
    $('#header_home').addClass('is-current');
  } else {
    $('#header_' + fix_path[1]).addClass('is-current');
  }

});

